import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    border: '1px solid #eeecec',
    '& .MuiCardHeader-root': {
        position: 'relative',
        '& .MuiLinearProgress-root': {
            position: 'absolute',
            bottom: 0,
            left: 0,
        },
        '& .MuiCardHeader-title': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
            fontSize: '1.2rem',
            fontWeight: 400,
        },
        '& .MuiCardHeader-avatar': {
            marginRight: 0,
        },
        '& .MuiCardHeader-subheader': {
            '& .MuiTabs-root': {
                '& .MuiTab-root': {
                    fontSize: '0.9rem',
                    textTransform: 'capitalize',
                    fontWeight: 400,
                    color: theme.palette.text.secondary,
                },
            }
        }
    },
    '& .MuiCardContent-root': {
        padding: theme.spacing(0),
        '& .MuiTableContainer-root': {
            '& .MuiTable-root': {
                '& .MuiTableHead-root': {
                    '& .MuiTableRow-root': {
                        '& .MuiTableCell-root': {
                            fontWeight: 400,
                            fontSize: '0.85rem',
                            textTransform: 'capitalize',
                        },
                    },
                },
                '& .MuiTableBody-root': {
                    '& .MuiTableRow-root': {
                        '& .MuiTableCell-root': {
                            fontWeight: 400,
                            color: theme.palette.text.primary,
                            fontSize: '0.85rem',
                            textTransform: 'capitalize',
                            '& .MuiAvatar-root': {},
                        },
                    },
                },
                '& .MuiTableFooter-root': {},
            },
        },
        '& .MuiDataGrid-root': {
            '& .MuiDataGrid-row': {
                '& .MuiDataGrid-cell': {
                    '& .MuiTypography-root': {
                        fontSize: '1rem',
                    },
                    '& .table-link': {
                        color: theme.palette.primary.main,
                        fontSize:'0.86rem',
                        lineHeight:'inherit',
                        cursor:'pointer',
                        textDecoration:'none',
                        '&:hover': {
                            textDecoration:'underline',

                        }
                    }
                },
            },
        },
    },
    '& .MuiCardActions-root': {
        padding: theme.spacing(3),
        width: '100%',
        justifyContent: 'space-between',
    }
}));


export const TableCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}